export default "__VITE_ASSET__BujG1a7J__"